import {Row, Select} from "antd";
import styled from "styled-components";

export const DashboardRow = styled(Row)`
    gap: 12px;
    margin-bottom: 24px;
    flex-wrap: wrap;

    @media (max-width: 576px) {
        gap: 8px;
        margin-bottom: 16px;
    }
`;

export const StatCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 16px 20px;
    min-width: 140px;
    flex: 1;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    cursor: ${({onClick}) => (onClick ? "pointer" : "default")};
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: ${({onClick}) =>
            onClick ? "0 2px 8px rgba(0,0,0,0.12)" : "0 1px 4px rgba(0,0,0,0.06)"};
    }

    .info {
        display: flex;
        flex-direction: column;
    }

    .label {
        font-size: 12px;
        color: #8c8c8c;
        margin-bottom: 2px;
        white-space: nowrap;
    }

    .value {
        font-size: 22px;
        font-weight: bold;
        color: ${({color}) => color || "#262626"};
    }

    @media (max-width: 576px) {
        padding: 8px 10px;
        gap: 8px;
        min-width: calc(50% - 8px);
        flex: 0 0 calc(50% - 8px);
        flex-direction: column;
        align-items: flex-start;

        .info {
            width: 100%;
        }

        .label {
            font-size: 9px;
            white-space: normal;
            line-height: 1.2;
            word-break: break-word;
        }

        .value {
            font-size: 15px;
        }
    }
`;

export const SectionCard = styled.div`
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    margin-bottom: 12px;
    overflow: visible;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    padding: 8px;

    .ant-collapse {
        background: transparent;
        border: none;
    }

    .ant-collapse-item {
        background: #fff !important;
        border: 1px solid #f0f0f0 !important;
        border-radius: 8px !important;
        margin-bottom: 8px !important;
        overflow: hidden;

        &:last-child {
            margin-bottom: 0 !important;
        }
    }

    .ant-collapse-content {
        background: #fafafa !important;

        .ant-collapse {
            .ant-collapse-item {
                background: #fff !important;
                border: 1px solid #f0f0f0 !important;
                border-radius: 8px !important;

                &:last-child {
                    margin-bottom: 0 !important;
                }
            }
        }
    }

    .ant-collapse-header {
        padding: 14px 14px 14px 14px !important;
        display: flex !important;
        align-items: center !important;

        .ant-collapse-arrow {
            display: none !important;
        }
    }

    .ant-collapse > .ant-collapse-item {
        border: 1px solid #f0f0f0 !important;
        border-radius: 8px !important;
    }
`;

export const Center = styled.div`
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Box = styled.div`
    height: 28px;
    min-width: 70px;
    padding: 0 10px;
    border-radius: 14px;
    display: flex;
    margin: 0 3px;
    align-items: center;
    justify-content: center;
    gap: 5px;
    background-color: ${({color}) => `${color}18`};
    transition: background 0.2s ease;
    font-size: 12px;

    &:hover {
        background-color: ${({color}) => `${color}35`};
    }

    @media (max-width: 576px) {
        height: 26px;
        min-width: 65px;
        padding: 0 9px;
        margin: 0 2px;
        gap: 4px;
        font-size: 11px;
    }
`;

export const CollapseHeaderNumber = styled.div`
    font-weight: 600;
    font-size: 15px;
    color: ${({color}) => color};

    @media (max-width: 576px) {
        font-size: 13px;
    }
`;

export const DataBoxRow = styled(Row)`
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;

    @media (max-width: 576px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
    }
`;

export const MetricRow = styled(Row)`
    flex-wrap: nowrap;
    overflow-x: auto;
    flex-shrink: 0;

    @media (max-width: 576px) {
        width: 100%;
        gap: 4px;
    }

    @media (max-width: 480px) {
        flex-wrap: wrap;
        overflow-x: visible;
        gap: 4px;
    }
`;
export const OptionsRow = styled(Row)`
    @media (max-width: 768px) {
        width: 100%;
        heigh: 100%;
    }
`;
export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        .ant-select-selector {
            min-width: 197px;
            font-size: 12px;
        }
    }
`;
